<template>
  <div v-if="this.isLoaded" class="">
    <div class="">
      <div class="row">
        <div class="col-sm-12 col-md-8 more-top-padding">
          <div class="justify-content-center-to-left">
            <div>Order: {{this.preOrder.orderId }}</div>
            <div>Requisition: {{this.preOrder.requisitionNumber}}</div>
            <br/>
            <label for="usByOrSell">
              Is the US the Buying or Selling party in the transaction?
            </label>
            <br />
            <el-radio-group
            data-vv-as="US Buy/Sell" 
            name="buySell"
              v-model="preOrder.usBuySell"
              :disabled="false"
            >
              <el-radio
                v-for="buySellOption in buySellOptions"
                :label="buySellOption.id"
                :key="buySellOption.id"
                >{{ buySellOption.name }}</el-radio
              >
            </el-radio-group>
            <br>
          </div>
          
        </div>
        <div class="col-sm-12 col-md-4 more-top-padding">
          <div class="justify-content-center-to-left">
            <label for="methodOfPayment">Method of Payment</label>
          <br />
            <el-radio-group
            data-vv-as="Method of Payment" 
            name="paymentMethod"
              v-model="preOrder.paymentMethodId"
              @change="paymentMethodChanged"
            >
              <el-radio
                tabindex="0"
                v-for="paymentMethod in paymentMethods"
                :label="paymentMethod.paymentMethodId"
                :key="paymentMethod.paymentMethodId"
                >{{ paymentMethod.name | toLowercase }}</el-radio
              >
            </el-radio-group>
            <textarea
                rows="8"
                placeholder="Reason for change. "
                class="el-textarea__inner"
                v-model="remarks"
                v-validate="'required'"
                name="remarks"
                :error="getError('remarks')"
              />
              <span v-show="errors.has('remarks')" class="error"
                >{{ errors.first("remarks") }}
              </span>
            <br>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="col-sm-12 col-md-12 more-top-padding">
          <div class="justify-content-center-to-left">
            <label for="lsssType">LSSS Type</label>
            <br />
              <el-radio-group
              tabindex="0"
                data-vv-as="LSSS Type" 
                name="lsssType"
                v-model="preOrder.lssTypeId"
                :disabled="false"
                @change="lsssTypeChanged"
              >
                <el-radio
                  v-for="lssType in lssTypes"
                  :label="lssType.lssTypeId"
                  :key="lssType.lssTypeId"
                  >{{ lssType.name }}</el-radio
                >
              </el-radio-group>
              <br>
              <span v-show="errors.has('lsssType')" class="error"
                >{{ errors.first("lsssType") }}
              </span>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-sm-12 more-top-padding">
          <div class="pull-right">
            <base-button
              :disabled="false"
              type="primary"
              wide
              @click.prevent="submit"
              class="btn-next"
              >Save</base-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <hr />
    <br />
    <div class="">
      <div class="row justify-content-center">
        <div class="col-sm-12 col-md-6">
          <label for="status">Status</label>
          <v-select
            id="status"
            v-model="selectedStatus"
            @input='onStatusChange'
            name="StatusDropdown"
            :reduce="(item) => item.id"
            label="name"
            :options="statusOptions"
            placeholder="Select"
          ></v-select>
        </div>
        <div class="col-sm-12 col-md-6 more-top-padding">
          <div class="pull-right">
            <base-button
              :disabled="false"
              type="primary"
              wide
              @click.prevent="updateOrderStatus"
              class="btn-next"
              >Save</base-button
            >
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
    <hr />
    <br />
  


    <div style="padding-left: 20px">
      <div class="row text-left">
      <div class="justify-content-center-to-left" > 
        <div style="margin-right: 50px">
          
        <label for="status">Assigned to Logistic User: </label>
        <div class="row">
          <i
            style="margin-top: 7px"
            v-if="
              selectedLogisticUserLabel
                ? selectedLogisticUserLabel.isLocked
                : false
            "
            class="tim-icons icon-lock-circle"
            aria-hidden="true"
          ></i>
          <v-select
            id="status"
            v-model="logisticUser"
            class="min_width"
            name="StatusDropdown"
            :reduce="(item) => item.id"
            label="name"

            :disabled="!isLogisticEditable"
            :options="filteredLogisticUsers"
            placeholder="Select"
          >
          <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
        </v-select>
          <el-button
            style="margin-left: 5px"
            size="mini"
            :class="isLogisticEditable ? 'editing' : 'btn-secondary'"
            :icon="isLogisticEditable ? 'el-icon-close' : 'el-icon-edit'"
            @click="toggleEditLogisticUser()"
          ></el-button>
          <el-button
            v-if="isLogisticEditable"
            style="margin-left: 2px"
            size="mini"
            class="btn-primary"
            icon="el-icon-check"
            @click="updateLogisticUser()"
          ></el-button>
        </div>
      </div>
      </div>

<br/>
<br/>
<br/>      

      <div style="margin-right: 50px"> 
        <label  for="status">Assigned to Finance User:</label>
          <div class="row">
            <i
              style="margin-top: 7px"
              v-if="
                selectedFinanceUserLabel
                  ? selectedFinanceUserLabel.isLocked
                  : false
              "
              class="tim-icons icon-lock-circle"
              aria-hidden="true"
            ></i>
            <v-select
              id="status"
              v-model="financeUser"
              class="min_width"
              name="StatusDropdown"
              :reduce="(item) => item.id"
              label="name"
              :options="filteredFinanceUsers"
              :disabled="!isFinanceEditable"
              placeholder="Select"
            >
            <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
            </v-select>

            <el-button
              style="margin-left: 5px"
              size="mini"
              :class="isFinanceEditable ? 'editing' : 'btn-secondary'"
              :icon="isFinanceEditable ? 'el-icon-close' : 'el-icon-edit'"
              @click="toggleEditFinanceUser()"
            ></el-button>
            <el-button
              v-if="isFinanceEditable"
              style="margin-left: 2px"
              size="mini"
              class="btn-primary"
              icon="el-icon-check"
              @click="updateFinanceUser()"
            ></el-button>
          </div>

      </div>
      <br/>
<br/>    
<br/>
      <div >
        <label for="status">Assigned to Partner Nation User:</label>
        <i
          style="margin-top: 7px"
          v-if="
            selectedPartnerUserLabel ? selectedPartnerUserLabel.isLocked : false
          "
          class="tim-icons icon-lock-circle"
          aria-hidden="true"
        ></i>
        <div class="row">
          <v-select
            id="status"
            v-model="partnerUser"
            name="StatusDropdown"
            class="min_width"
            :reduce="(item) => item.id"
            label="name"
            :options="filteredPartnerUsers"
            :disabled="!isPartnerNationEditable"
            placeholder="Select"
          >
          <template v-slot:option="option">
              {{ option.nameLabel }}
            </template>
        </v-select>
          <el-button
            v-if="agreementInfoSelectedCountryId"
            style="margin-left: 5px"
            size="mini"
            :class="isPartnerNationEditable ? 'editing' : 'btn-secondary'"
            :icon="isPartnerNationEditable ? 'el-icon-close' : 'el-icon-edit'"
            @click="toggleEditPartnerNation()"
          ></el-button>
          <el-button
            v-if="isPartnerNationEditable"
            style="margin-left: 2px"
            size="mini"
            class="btn-primary"
            icon="el-icon-check"
            @click="updatePartnerUser()"
          ></el-button>
        </div>
      </div>
    </div>
      
      <br/>
      <div class="row justify-content-center">
   
      </div>
    </div>





  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { Select, Option, Radio, RadioGroup, Input, Button } from "element-ui";
import Util from "../../../../util/util";
import axios from "@/axios";

const SUCCESS_MESSAGE = "Pre Order Details Module Saved";
export default {
  props: ["isReadOnly", "selectedOrderId"],
  name: "pre-order-detail-super-admin",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Input.name] : Input,
    [Button.name]: Button,
    Treeselect,


  },
  data() {
    return {
      loading: false,
      buySellOptions: [
        {
          id: "BUY",
          name: "Buy",
        },
        {
          id: "SELL",
          name: "Sell",
        },
      ],
      preOrder: undefined,
      statusOptions: [],
      selectedStatus: "",
      duringSubmit: false,
      selectedStatusLabel: "",
      logisticUser : null,
      financeUser: null,
      partnerUser: null,
      isLogisticEditable: false,
      isFinanceEditable: false,
      isPartnerNationEditable: false,
      remarks: "",
      orderStatusMap: {
          1: "DRAFT",
          2: "SUBMITTED",
          3: "AUTHORIZED",
          4: "RECEIVED",
          5: "INVOICED",
          6: "COMPLETED",
          7: "CANCELLED",
          8: "BILLED",
          9: "RETURNED"
      },
      oldPaymentOfMenthod: ''
    };
  },
  computed: {
    ...mapGetters({
      lssTypes: "lsstype/allLssTypes",
      jointStaffOrganizations: "organization/jointStaffOrganizations",
      paymentMethods: "paymentmethod/paymentMethods",
      isMonetaryOrder: "preOrderDetail/isMonetaryOrder",
      logisticsUsers: "users/logisticsUsers",
      financeUsers: "users/financeUsers",
      partnerNationUsers: "users/partnerNationUsers",
      agreementInfoSelectedCountryId:
      "agreementInformation/agreementInfoSelectedCountryId",
      orderMetadata: "orderMetadata/orderMetadata",
      
    }),
    orderId() {
      return (this.selectedOrderId !== undefined) ? this.selectedOrderId : undefined;
    },
   
  async   isLoaded() {
      if(this.preOrder !== undefined && this.preOrder.orderId !== 0) {
        await this.getOrderMetadata(this.preOrder.orderId);
        this.logisticUser =  this.orderMetadata.logisticsUserId,
        this.financeUser = this.orderMetadata.financeUserId,
        this.partnerUser = this.orderMetadata.partnerNationId,  
        await this.getLogisticsUsers(true);
        await this.getFinanceUsers(true);
        await this.loadAgreementInformation(this.preOrder.orderId);
        await this.getPartnerNationUsers(this.agreementInfoSelectedCountryId);
        return true;
      } else {
        return false;
      }
    },
    shouldEnable() {
      return (this.isReadOnly || this.isOrderSubmitted || this.isPartnerAccount) && !this.isSuperAdmin;
    },
    isOrderSubmitted() {
      return this.orderMetadata.orderStatus !== Util.ORDER_STATUS_DRAFT;
    },
     acsaCeilingJustificationCharacterCountMessage() {
      if (this.preOrder.acsaCeilingJustification && this.preOrder.acsaCeilingJustification.length != null) {
        return 250 - this.preOrder.acsaCeilingJustification.length + " Characters Remaining";
      } else {
        return "250 Characters Remaining";
      }
    },
    hasAcsaCeiling() {
      const YES = "YES"
      return this.preOrder.hasAcsaCeiling && this.preOrder.hasAcsaCeiling === YES
    },
    filteredFinanceUsers(){
      let selectedUser =  this.financeUsers.filter((e)=> e.id == this.financeUser)
      if(selectedUser.length && selectedUser[0].lockedBy){
         return [...selectedUser , ...this.financeUsers.filter((e)=> e.lockedBy == null || undefined)]
      }else{
         return this.financeUsers.filter((e)=> e.lockedBy == null || undefined)
      }
       
     },
     selectedFinanceUserLabel() {
       let selectedUser;
      if(this.financeUser) {
        selectedUser = this.financeUsers.find(user => user.id === this.financeUser);
      
        return selectedUser ? {label: selectedUser.nameLabel, isLocked : selectedUser.lockedBy ? true  : false }  : {label: 'No Finance user selected'};
     }  
     },
     filteredLogisticUsers() {
      let selectedUser = this.logisticsUsers.filter((e) => e.id == this.logisticUser)
      if (selectedUser.length && selectedUser[0].lockedBy) {
        return [...selectedUser, ...this.logisticsUsers.filter((e) => e.lockedBy == null || undefined)]
      } else {
        return this.logisticsUsers.filter((e) => e.lockedBy == null || undefined)
      }

    },
    filteredPartnerUsers() {
      let selectedUser = this.partnerNationUsers.filter((e) => e.id == this.partnerUser)
      if (length.length && selectedUser[0].lockedBy) {
        return [...selectedUser, ...this.partnerNationUsers.filter((e) => e.lockedBy == null || undefined)]
      } else {
        return this.partnerNationUsers.filter((e) => e.lockedBy == null || undefined)
      }

    },
   selectedLogisticUserLabel() {
      let selectedUser;
      if (this.logisticUser) {
      selectedUser = this.logisticsUsers.find(user => user.id === this.logisticUser);
      return selectedUser ? { label: selectedUser.nameLabel, isLocked: selectedUser.lockedBy ? true : false } : { label: 'No logistic user selected' };
    }},
    selectedPartnerUserLabel() {
      let selectedUser;
      if (this.selectedUserId) {
      selectedUser = this.partnerNationUsers.find(user => user.id === this.partnerUser);
      return selectedUser ? { label: selectedUser.nameLabel, isLocked: selectedUser.lockedBy ? true : false } : { label: 'No logistic user selected' };
    }},
  },
 
  filters: {
    toLowercase: function (value) {
      if (!value) return "";
      if (value === Util.MONETARY) {
        value = value.toString().toLowerCase();
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
      return value;
    },
  },
  created() {
    this.getLssTypes();
    this.getPaymentMethods();
  },
  methods: {
    ...mapActions({
      getLssTypes: "lsstype/getLssTypes",
      getPaymentMethods: "paymentmethod/getPaymentMethods",
      getLogisticsUsers: "users/getLogisticsUsers",
      getFinanceUsers: "users/getFinanceUsers",
      getPartnerNationUsers: "users/getPartnerNationUsers",
      loadAgreementInformation: "agreementInformation/loadAgreementInformation",
      onFinanceChange: "orderMetadata/onFinanceChange",
      onLogisticsChange: "orderMetadata/onLogisticsChange",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      onPartnerNationChange: "orderMetadata/onPartnerNationChange",
    }),
    async updateFinanceUser(){
      this.$loaderApp.addRequest();
      
        try{
      await this.onFinanceChange({
          orderId: this.preOrder.orderId,
          sendAssignerCopy: false,
          note: '',
          selectedUserId: this.financeUser,
        });
        this.$loaderApp.completeRequest();
        this.isFinanceEditable = false
        this.$toast.success("Order Updated Successfully");
      }catch(err){
        this.financeUser = this.orderMetadata.financeUserId,
        this.isFinanceEditable = false
        this.$loaderApp.completeRequest();
        this.$toast.error("Error Updating Order");

      }
    },
    async updatePartnerUser(){
      this.$loaderApp.addRequest();
        try{
      await this.onPartnerNationChange({
          orderId: this.preOrder.orderId,
          sendAssignerCopy: false,
          note: '',
          selectedUserId: this.partnerUser,
        });
        this.$loaderApp.completeRequest();
        this.isPartnerNationEditable = false
        this.$toast.success("Order Updated Successfully");
      }catch(err){
        this.isPartnerNationEditable = false
        this.partnerUser = this.orderMetadata.partnerNationId,  
        this.$loaderApp.completeRequest();
        this.$toast.error("Error Updating Order");

      }
      
    },
    toggleEditLogisticUser(){
      if (this.isLogisticEditable) {
        this.isLogisticEditable = false
        this.logisticUser =  this.orderMetadata.logisticsUserId;
      } else {
        this.isLogisticEditable = true
      }
    },
    toggleEditFinanceUser(){
      if (this.isFinanceEditable) {
        this.isFinanceEditable = false
        this.financeUser = this.orderMetadata.financeUserId;
      } else {
        this.isFinanceEditable = true
      }
    },
    toggleEditPartnerNation(){
      if (this.isPartnerNationEditable) {
        this.isPartnerNationEditable = false
        this.partnerUser = this.orderMetadata.partnerNationId;
      } else {
        this.isPartnerNationEditable = true
      }
    },
    async updateLogisticUser(){
      this.$loaderApp.addRequest();
      try{
      await this.onLogisticsChange({
          orderId:  this.preOrder.orderId,
          sendAssignerCopy: false,
          note: '',
          selectedUserId: this.logisticUser,
        });
        this.$loaderApp.completeRequest();
        this.isLogisticEditable = false
        this.$toast.success("Order Updated Successfully");
      }catch(err){
        this.logisticUser =  this.orderMetadata.logisticsUserId,
       
        this.isLogisticEditable = false
        this.$loaderApp.completeRequest();
        this.$toast.error("Error Updating Order");
      }
    },
    async onStatusChange(e) {
      this.selectedStatusLabel = this.orderStatusMap[e];
    },
 
    async getCurrentOrderStatus() {
      const res = await axios.get(`/api/orders/order/currentstatus/${this.orderId}`);
      this.selectedStatus = res.data;
      this.selectedStatusLabel = this.orderStatusMap[res.data];
    },
    async getAllStatuses() {
      const response = await axios.get("/api/orderstatuses")
      this.statusOptions = response.data;
    },
    async searchOrder() {
      if(this.orderId === undefined) {
        this.$toast.error('Order Id cannot be undefined');
      } else {
        try {
          var res = await axios.get(`/api/orders/preorder/${this.orderId}`);
          this.preOrder = res.data;
          this.oldPaymentOfMenthod = this.preOrder.paymentMethodId;
          if(this.preOrder.orderId == 0){
            this.$emit('get-preorder-res', false);
            if(this.selectedOrderId.includes("-")) {

          this.$toast.error(` Requisition ${this.selectedOrderId} cannot be loaded/or doesn't exist`);
        } else {
          this.$toast.error(`Order ${this.selectedOrderId} cannot be loaded/or doesn't exist`);
        }
          } else {
            if(this.selectedOrderId.includes("-")){
              this.$toast.success(`Requisition ${this.selectedOrderId} loaded`);
            }else{
              this.$toast.success(`Order ${this.selectedOrderId} loaded`);
            }
            await this.getCurrentOrderStatus();
            await this.getAllStatuses();
            this.$emit('get-preorder-res', true);
          
          }
        } catch(err) {
          this.$emit('get-preorder-res', false);
        }
      }
    },
    lsssTypeChanged(e) {
      if(this.preOrder.isFromBackend) {
        return;
      }

      if((e === Util.STANDARD || e === Util.OPEN_ENDED) && this.preOrder.paymentMethodId === Util.MONETARY) {
        this.preOrder.hasAcsaCeiling = "YES"
        return;
      }

      if((e === Util.SME_LOAN || e === Util.LIFT_AND_SUSTAIN || this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT) && this.preOrder.paymentMethodId === Util.MONETARY) {
        this.preOrder.hasAcsaCeiling = "NO"
        return;
      }
    },
    paymentMethodChanged(e) {
      if(e === Util.MONETARY) {
        if(this.preOrder.lssTypeId === Util.STANDARD || this.preOrder.lssTypeId === Util.OPEN_ENDED) {
        this.preOrder.hasAcsaCeiling = "YES"
        return;
        }
         if(this.preOrder.lssTypeId === Util.SME_LOAN || this.preOrder.lssTypeId === Util.LIFT_AND_SUSTAIN || this.preOrder.lssTypeId === Util.STRATEGIC_AIRLIFT) {
        this.preOrder.hasAcsaCeiling = "NO"
        return;
      }
      }
        this.preOrder.hasAcsaCeiling = null;
        this.preOrder.acsaCeilingJustification = null;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async updateOrderStatus(e) {
      try {
        //this.duringSubmit = true;
        this.$loaderApp.addRequest();
        if(this.selectedOrderId !== "" ) {
          const options = {
            'Content-Type': 'application/json'
          };
          var data = {
            'id': this.selectedStatus,
            'name': this.selectedStatusLabel,
            'sortOrder': 0
          };
          var res = await axios.post(`/api/orders/orderstatus/${this.preOrder.orderId}`, 
          data, options);
          if(res.status === 200) {
            // reload the order
            await this.searchOrder();
            this.$loaderApp.completeRequest();
          }
        } else {
          //this.duringSubmit = false;
          this.$loaderApp.completeRequest();
          this.$toast.error('Error on updating');
        }
        
       
      } catch(e) {
        //this.duringSubmit = false;
        this.$loaderApp.completeRequest();
        this.$toast.error('Error on updating');
      }
    },
    async savePreOrderSuperAdmin() {
      try {
        let ret = await this.$validator.validateAll();
        if(ret) {
          this.preOrder.remarks = this.remarks;

          // check if the order is changed to monetary
          if(this.preOrder.paymentMethodId === Util.MONETARY && this.oldPaymentOfMenthod !== this.preOrder.paymentMethodId) {
            this.preOrder['isMethodToMonetary'] = true;
          } else {
            this.preOrder['isMethodToMonetary'] = false;
          }
          const dataToSend = Object.assign({}, this.preOrder);
          const options = {
            'Content-Type': 'application/json'
          };
          //The DODAAC must be null or a valid 6 character string when sent to the server.  If it is an empty string set it to null.
          if (!Util.isNull(dataToSend) && Util.isNullOrEmpty(dataToSend.dodAac)) {
              dataToSend.dodAac = null;
          }
          await axios.post('/api/orders', dataToSend, options);
          await this.searchOrder();
        }
      } catch(e) {
        this.$toast.error('Error on updating');
      }
    },
    async submit(e) {
      if (!(this.preOrder === undefined || this.preOrder.orderId === 0)) {
          //this.duringSubmit = true;
          this.$loaderApp.addRequest();
          const ctx = this;
          await ctx.savePreOrderSuperAdmin(ctx.preOrder);
          //this.duringSubmit = false;
          this.$loaderApp.completeRequest();
      } else {
          //this.duringSubmit = false;
          this.$loaderApp.completeRequest();

          this.$toast.error("Error on saving");
      }
    },
  },
};
</script>

<style scoped lang="scss">

.min_width{
  // min-width: 500px;
  min-width: 300px;
}


.has-danger:after {
  margin-right: 10px;
}



.vue-treeselect__x-container,
.vue-treeselect__control-arrow,
.vue-treeselect__single-value {
  color: #10b45a;
}

.white-content .form-group .el-input__inner[readonly] {
  background-color: transparent;
}

.el-radio__inner {
  border-color: #000;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #000 !important;
  background: #000;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #000;
}

.justify-content-center-to-left {
  display: flex;
  flex-direction: column;
  align-items:flex-start;
  align-content:space-around;
  column-gap: 0px;
  row-gap: 0px;
}
</style>
